
<template>
    <el-container  class="page-x flex-all-center" direction="vertical">
        <div class="mb20" style="font-size:48px;">欢迎使用</div>
        <div class="mb20" style="font-size:48px;">汇晨互动智能健康评估系统</div>
    </el-container>
</template>

<script>
export default {
    name: 'Home',
    data(){
        return {

        }
    },
    mounted(){
        this.$root.breadList = [];
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped></style>
